export interface ApiErrorResponse {
    success: boolean;
    message: string;
    code: string;
}

export const getErrorTitle = (code: string): string => {
    switch (code) {
        case 'SLOT_CONFLICT':
            return 'Booking Conflict';
        case 'ROOM_NOT_FOUND':
            return 'Room Not Found';
        case 'PAYMENT_FAILED':
            return 'Payment Failed';
        case 'USER_DATA_MISSING':
            return 'Missing Information';
        case 'INTERNAL_ERROR':
            return 'Server Error';
        default:
            return 'Error';
    }
};

export const getErrorMessage = (code: string, defaultMessage: string): string => {
    switch (code) {
        case 'SLOT_CONFLICT':
            return `The selected time slot is already booked by another user. Please choose a different time.`;
        case 'ROOM_NOT_FOUND':
            return 'The room you are trying to book is no longer available.';
        case 'PAYMENT_FAILED':
            return `Payment could not be processed. Please try again or contact support.`;
        case 'USER_DATA_MISSING':
            return `Required information is missing. Please complete all required fields.`;
        case 'INTERNAL_ERROR':
            return 'An unexpected error occurred. Please try again or contact support.';
        default:
            return defaultMessage || 'An error occurred. Please try again.';
    }
};

export const parseApiError = (error: any): {title: string, message: string} => {
    if (error?.response?.data) {
        const errorData = error.response.data;
        
        // Check if it's the new format
        if (errorData.success === false && errorData.code) {
            return {
                title: getErrorTitle(errorData.code),
                message: getErrorMessage(errorData.code, errorData.message || '')
            };
        }
        
        // Fallback to old format
        if (errorData.error) {
            return {
                title: 'Booking Error',
                message: errorData.error
            };
        }
    }
    
    // Generic error
    return {
        title: 'Error',
        message: error?.message || 'An unexpected error occurred. Please try again.'
    };
};

export const setupGlobalErrorHandlers = () => {
    // Handle unhandled promise rejections
    window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
        console.error('Unhandled promise rejection:', event.reason);
    });

    // Handle general errors
    window.addEventListener('error', (event) => {
        console.error('Global error:', event.error);
    });
};
